const TITLES = {
    DAME: 'Dame',
    DR: 'Dr',
    LADY: 'Lady',
    LORD: 'Lord',
    MISS: 'Miss',
    MR: 'Mr',
    MRS: 'Mrs',
    MS: 'Ms',
    MX: 'Mx',
    PROF: 'Prof',
    SIR: 'Sir',
    CUSTOM: 'Not selected'
};

const GENDERS = {
    MALE: 'Male',
    FEMALE: 'Female',
    TRANS_MALE: 'Male trans',
    TRANS_FEMALE: 'Female trans',
    NON_BINARY: 'Non-Binary',
    CUSTOM: 'Not selected'
};

const DEFAULT_PHOTO = {
    DEFAULT_MALE: 'https://www.moblab.com/images/avatar-placeholder.jpg',
    DEFAULT_FEMALE:
        'https://media.istockphoto.com/vectors/default-avatar-profile-icon-grey-photo-placeholder-hand-drawn-modern-vector-id1273297903?k=20&m=1273297903&s=170667a&w=0&h=7-nYuX1B59FiEEI4NjXiZlyFWFJYtXr_TgKEHxMdkNk='
};

const REFERRAL_SOURCES_TYPE = {
    WORD_OF_MOUTH: 'Word of mouth',
    WEBSITE: 'Website',
    INSTAGRAM: 'Instagram',
    FACEBOOK: 'Facebook',
    TWITTER: 'Twitter',
    WALK_PAST: 'Walk past',
    INTERNET: 'Internet',
    GOOGLE_SEARCH: 'Google search',
    FRIEND: 'Friend',
    DR_REFERRAL: 'Dr referral',
    CUSTOM: 'Other'
};

const DEFAULT_ETHNICITY_OPTIONS = ['Asian', 'Black', 'Mixed', 'White', 'Other'];

const DEFAULT_STATUS_OPTIONS = [];

const MARKETING_DATA_FIELD_NAMES = [
    'campaignTerm',
    'campaignContent',
    'campaignName',
    'campaignSource',
    'campaignMedium',
    'firstPageVisited',
    'gclid',
    'pageEnquiredThrough'
];

const RELATIONSHIP_TYPE = {
    CHILD: 'Child',
    FRIEND: 'Friend',
    GRANDPARENT: 'Grandparent',
    PARENT: 'Parent',
    SPOUSE: 'Spouse',
    OTHER_FAMILY: 'Other family',
    OTHER: 'Other'
};

const NOTIFICATION_TYPES = {
    SMS: 'SMS',
    EMAIL: 'Email'
};

const PHONE_TYPE_OPTIONS = {
    WORK: 'Work',
    HOME: 'Home'
};

const LEAD_STATUS = {
    OPEN: 'Open',
    WON: 'Won',
    LOST: 'Lost'
};

const LEAD_STAGES_PROTECTED = { WON: 'Closed - Won', LOST: 'Closed - Lost' };

const RELATIONSHIPS = {
    SPOUSE: 'SPOUSE',
    PARTNER: 'PARTNER',
    PARENT: 'PARENT',
    CHILD: 'CHILD',
    FRIEND: 'FRIEND'
};

const PROFESSIONAL_BODIES = {
    GENERAL_MEDICAL_COUNCIL: 'GMC',
    GENERAL_PHARMACEUTICAL_COUNCIL: 'GPhC',
    NURSING_AND_MIDWIFERY_COUNCIL: 'NMC',
    GENERAL_DENTAL_COUNCIL: 'GDC',
    HEALTH_AND_CARE_PROFESSIONS_COUNCIL: 'HCPC',
    PHARMACEUTICAL_SOCIETY_OF_NORTHERN_IRELAND: 'PSNI',
    GENERAL_OPTICAL_COUNCIL: 'GOC',
    GENERAL_CHIROPRACTIC_COUNCIL: 'GCC',
    GENERAL_OSTEOPATHIC_COUNCIL: 'GOsC',
    NONE: 'NONE'
};

const COMMISSION_RANGE_TYPES = ['product', 'service', 'course', 'total'];

const COMMISSION_CONDITIONS = {
    SELL: 'SELL',
    PERFORM: 'PERFORM',
    BOTH: 'BOTH'
};

const AMOUNT_FEE_TYPE = {
    PERCENTAGE: '%',
    AMOUNT: 'Amount'
};

const ROLES = {
    ADMIN: 'admin',
    CUSTOMER: 'customer',
    PRACTITIONER: 'practitioner'
};

const LATE_CANCELLATION_CHARGE = {
    NONE: 'NONE',
    AMOUNT: 'AMOUNT',
    PERCENTAGE: 'PERCENTAGE'
};

const SERVICE_AVAILABILITIES = {
    BOOK_AND_SELL: 'BOOK_AND_SELL',
    BOOK_ONLY: 'BOOK_ONLY',
    SELL_ONLY: 'SELL_ONLY'
};

const GIFT_VOUCHER_AMOUNT = [50, 100, 150, 200, 250, 500];

const MEDICAL_TYPES = {
    MEDICAL: 'Medical',
    COSMETIC: 'Cosmetic'
};

const MEDICAL_TYPES_COLOURS = {
    NONE: '#4d4352',
    MEDICAL: '#116400',
    COSMETIC: '#a1156b'
};

const APPOINTMENT_TYPES = {
    APPOINTMENT: 'Appointment',
    BREAK: 'Break',
    BLOCK: 'Block',
    LEAVE: 'Leave'
};

const APPOINTMENT_REPEAT = {
    NEVER: 'never',
    EVERY_DAY: 'everyDay',
    EVERY_WEEK: 'everyWeek',
    EVERY_TWO_WEEKS: 'everyTwoWeeks',
    EVERY_MONTH: 'everyMonth'
};

const APPOINTMENT_PAYMENT_TYPES = {
    CASH: 'Cash',
    CREDIT_CARD: 'Card',
    GIFT_CARD: 'Gift Voucher'
};

const INVOICE_PAYMENT_TYPES = {
    ACCOUNT_BALANCE: 'Account',
    CREDIT_CARD: 'Card',
    GIFTCARD: 'Giftvoucher',
    CREDIT_CARD_TERMINAL: 'Card Terminal',
    BANK_TRANSFER: 'Bank transfer',
    ONLINE: 'Online',
    FOC: 'FOC',
    CUSTOM: 'Custom',
    CASH: 'Cash'
    /*CHEQUE: 'Cheque',
    DEBIT_CARD: 'Debit card'*/
};

const DEFAULT_PAYMENT_TYPES = [
    {
        name: INVOICE_PAYMENT_TYPES.CREDIT_CARD,
        label: 'Credit card',
        active: true
    },
    {
        name: INVOICE_PAYMENT_TYPES.GIFTCARD,
        label: 'Gift voucher',
        active: true
    },
    {
        name: INVOICE_PAYMENT_TYPES.ACCOUNT_BALANCE,
        label: 'Account',
        active: true
    },

    {
        name: INVOICE_PAYMENT_TYPES.CASH,
        label: 'Cash',
        active: true
    },
    {
        name: INVOICE_PAYMENT_TYPES.BANK_TRANSFER,
        label: 'Bank Transfer',
        active: true
    },
    {
        name: INVOICE_PAYMENT_TYPES.ONLINE,
        label: 'Online',
        active: true
    },
    {
        name: 'Cheque',
        label: 'Cheque',
        active: true
    }
];

const FIXED_PAYMENT_OPTIONS = [
    INVOICE_PAYMENT_TYPES.CREDIT_CARD,
    INVOICE_PAYMENT_TYPES.GIFTCARD,
    INVOICE_PAYMENT_TYPES.ACCOUNT_BALANCE
];

const APPOINTMENT_STATUS_TYPES = {
    NO_SHOW: 'No show',
    DELETED: 'Deleted',
    CANCELED: 'Cancelled',
    SCHEDULED: 'Scheduled',
    COMPLETED: 'Completed',
    RUNNING_LATE: 'Running late',
    PENDING: 'Pending',
    INCOMPLETE: 'Incomplete'
};

const INVOICE_ORIGIN = {
    SALE: 'SALE',
    REFUND: 'REFUND',
    CANCELLATION: 'CANCELLATION',
    ONLINE_COURSE: 'ONLINE_COURSE'
};

const STOCK_TAKE = {
    STATUS: {
        COUNT_PAUSED: 'Count paused',
        COMPLETE: 'Complete',
        STOCK_UPDATE: 'Stock update'
    }
};

const ORDER = {
    STATUS: {
        DRAFT: 'Draft',
        RAISED: 'Raised',
        AWAITING_DELIVERY: 'Awaiting delivery',
        PART_DELIVERED: 'Part delivered',
        COMPLETED: 'Completed'
    },
    HIST_STATUS: {
        PROGRESS: 'Progress',
        COMPLETE: 'Complete'
    },
    STOCK_QUANTITY_TYPE: {
        MIN_OR_LESS: 'Min stock or less',
        LESS_THAN_MAX: 'Less than max stock',
        ALL_PRODUCTS: 'All products'
    }
};

const CURRENCY_TYPES = [
    {
        NAME: 'GBP',
        LANGUAGE: 'en-GB',
        SYMBOL: '£',
        LABEL: '£ Pound'
    },
    {
        NAME: 'USD',
        LANGUAGE: 'en-US',
        SYMBOL: '$',
        LABEL: '$ USD'
    },
    {
        NAME: 'EUR',
        LANGUAGE: 'en-GB',
        SYMBOL: '€',
        LABEL: '€ Euro'
    },
    {
        NAME: 'AUD',
        LANGUAGE: 'en-AU',
        SYMBOL: '$',
        LABEL: '$ AUD'
    }
];

const GIFTCARD = {
    STATUS: {
        USED: 'Used',
        AVAILABLE: 'Available',
        EXPIRED: 'Expired',
        UNPAID: 'Unpaid',
        REFUNDED: 'Refunded'
    }
};

const APPOINTMENT_FILTER_GROUPS = {
    ALL: 'ALL',
    UPCOMING: 'UPCOMING',
    PAST: 'PAST',
    COURSES: 'COURSES',
    CANCELED: 'CANCELED',
    NO_SHOW: 'NO SHOW',
    DELETED: 'DELETED'
};

const POPUP = {
    TYPES: {
        NONE: 'None',
        CHECK_IN: 'Check in',
        CHECK_OUT: 'Check out',
        //  CLIENT_CARD: 'Client Card',
        BOOKING: 'Booking',
        ALL: 'All'
    },
    STATUS: {
        ACTIVE: 'ACTIVE',
        NO_SHOW: 'NO SHOW',
        DELETED: 'DELETED'
    }
};

const TEMPORARY_DISCOUNTS = {
    DISCOUNT_TYPES: {
        PERCENTAGE: 'Percentage',
        FIXED_AMOUNT: 'Fixed amount'
    },
    APPLY: {
        TOTAL: 'Total invoice',
        ITEM: 'Invoice line items'
    },
    ITEMS_TYPES: {
        PRODUCT: 'Product',
        COURSE: 'Course',
        SERVICE: 'Service'
    }
};

const INVOICE_PAYMENT_STATUS = {
    UNPAID: 'Unpaid',
    PART_PAID: 'Part paid',
    PAID: 'Paid',
    VOID: 'Void',
    REFUND: 'Refund'
};

const COHERENT_PAYMENT_PROCESS_STATUS = {
    WAITING: '',
    PROCESSING: 'Processing',
    DONE: 'DONE',
    VOID: 'VOID'
};

const TAXTYPES = {
    withTax: '20% VAT',
    withoutTax: 'Exempt (0%)'
};

const DISCOUNT_TYPES = {
    currency: 'currency',
    percentage: 'percentage'
};

const STATUS_ACTIVE = 10;
const STATUS_DELETED = 100;

const COURSES_GROUP = {
    all: 'All',
    active: 'Active',
    completed: 'Completed',
    expired: 'Expired / Voided'
};

const RECEIPT_STATUS = {
    DECLINED: 'DECLINED',
    REFUND: 'REFUND',
    RECEIVED: 'RECEIVED'
};

const INVOICE_ITEM_TYPES = {
    ACCOUNT: 'Account',
    COURSE: 'Course',
    GIFTCARD: 'Giftvoucher',
    MEMBERSHIP: 'Membership',
    PRE_PAID_CARD: 'Prepaid Card',
    PRODUCT: 'Product',
    SERVICE: 'Service'
};

const ONLINE_PURCHASE_INVOICE_DESCRIPTION = {
    GIFT_VOUCHER: 'Online Gift Voucher Purchase'
};

const TEST_EMAILS = [
    'askari@townshendskinclinic.co.uk',
    'at@collums.co',
    'at+3@askinology.com',
    'zurek.robert@gmail.com',
    'zurek.robert+clinic@gmail.com',
    'robert.zurek@sensilabs.pl',
    'piotr.kowalski@sensilabs.pl',
    'cezary.jagiello@sensilabs.pl',
    'slawomir.kowalski@sensilabs.pl',
    'kamil.bonislawski@sensilabs.pl',
    'kamil.bonislawski@sensilabs.pl',
    'piotr.zych@sensilabs.pl',
    'marek.swietlik@sensilabs.pl',
    'sylwia.maslankowska@sensilabs.pl',
    'arron@continuiti.co.uk',
    'mateusz.konopka@sensilabs.pl'
];

const WIDGET_TYPES = {
    TEXT_WIDGET: 'Text',
    PARAGRAPH_WIDGET: 'Paragraph',
    CHECKBOX_WIDGET: 'Checkbox',
    RADIO_WIDGET: 'Radio',
    AUTOCOMPLETE_WIDGET: 'AutoComplete',
    TITLE_WIDGET: 'Title',
    SELECT_WIDGET: 'Select',
    IMAGE_WIDGET: 'Image',
    RADIO_AUTOCOMPLETE_WIDGET: 'RadioAutoComplete',
    RADIO_TEXT_WIDGET: 'RadioText',
    SIGNATURE_FIELD_WIDGET: 'SignatureField',
    PRACTITIONER_SIGNATURE_FIELD_WIDGET: 'PractitionerSignatureField',
    LIST_WIDGET: 'List',
    RADIO_LIST_WIDGET: 'RadioList',
    TEXT_AREA_WIDGET: 'TextArea',
    BLOCK_WIDGET: 'Block'
};

const ORGANISATION_FORM_TYPES = {
    CONSENT: 'Consent',
    MEDICAL: 'Medical',
    GENERAL: 'General',
    AFTERCARE: 'Aftercare'
};

const WIDGET_GROUPS = {
    NONE: 'None',
    ALLERGIES: 'Allergies',
    DRUG_HISTORY: 'Drug History',
    MEDICAL_HISTORY: 'Medical History'
};

const IMAGE_WIDGET_ALIGNMENT = {
    LEFT: 'Left',
    CENTER: 'Center',
    RIGHT: 'Right'
};
const IMAGE_WIDGET_SIZE = {
    SMALL: 'Small',
    MEDIUM: 'Medium',
    BIG: 'Big'
};

const FORM_OPTIONS = {
    TABLETS: 'Tablets',
    CAPSULES: 'Capsules',
    CREAM: 'Cream',
    LIQUID: 'Liquid',
    SOLUTION: 'Solution for injection',
    SUPPOSITORIES: 'Suppositories',
    DROPS: 'Drops',
    OTHER: 'Other (write in notes)'
};

const PRESCRIPTION_ROUTES = {
    BUCCAL: 'Buccal',
    TOPICAL: 'Topical',
    ORAL: 'Oral',
    INTRAMUSCULAR: 'Intramuscular',
    IV: 'IV',
    NASAL: 'Nasal',
    OTIC: 'Otic',
    OCULAR: 'Ocular',
    RECTAL: 'Rectal',
    SUBCUTANEOUS: 'Subcutaneous',
    SUBLINGUAL: 'Sublingual',
    TRANSDERMAL: 'Transdermal',
    VAGINAL: 'Vaginal'
};

const DOSE_UNITS = {
    DOSE: 'Dose',
    GRAMS: 'g',
    MICROGRAMS: 'mcg',
    MILIGRAMS: 'mg',
    MILILITRES: 'ml',
    TABLETS: 'Tablet(s)',
    UNITS: 'Units',
    PERCENTAGE: '%'
};

const DURATION_UNITS = {
    DAYS: 'Days',
    WEEKS: 'Weeks',
    MONTHS: 'Months',
    TABLETS: 'Tablets',
    CAPSULES: 'Capsules',
    SUPPOSITORIES: 'Suppositories'
};

const TREATMENT_NOTE_TYPES = {
    MEDICAL: 'Medical Note',
    TREATMENT: 'Treatment Record'
};

const TREATMENT_TYPES = {
    GENERAL: 'General',
    TOXIN: 'Toxin',
    FILLER: 'Filler',
    LHR: 'Lightsheer',
    BLIPL: 'Basic laser / IPL'
};

const TREATMENT_AREAS = {
    CHEEKS: 'Cheeks',
    LIPS: 'Lips',
    CHIN: 'Chin',
    PERI_ORAL: 'Peri oral',
    TEAR_TROUGH: 'Tear trough',
    JAW: 'Jaw',
    NOSE: 'Nose',
    FOREHEAD: 'Forehead',
    TOP_LIP: 'Top Lip',
    OTHER: 'Other'
};

const PRODUCT_TYPES = {
    RETAIL: 'Retail',
    PROFESSIONAL: 'Professional'
};

const DILUTION_UNITS = [
    '0.5ml',
    '0.63ml',
    '1.0mls',
    '1.25mls',
    '2.0mls',
    '2.5mls',
    '3.0mls',
    '4.0mls',
    '5.0mls',
    '8.0mls'
];

const PRESCRIPTION_FREQUENCY_VALUES = {
    ONCE_DAILY: 'once daily',
    TWICE_DAILY: 'twice daily',
    THREE_TIMES_DAILY: 'three times daily',
    FOUR_TIMES_DAILY: 'four times daily',
    FIVE_TIMES_DAILY: 'five times daily',
    EVERY_FOUR_HOURS: 'every four hours',
    EVERY_MORNING: 'every morning',
    EVERY_NIGHT: 'every night',
    ONCE_WEEKLY: 'once a week',
    TWICE_WEEKLY: 'twice a week',
    THREE_TIMES_WEEKLY: 'three times a week',
    EVERY_DAY: 'every day',
    AS_REQUIRED: 'as required',
    WHEN_REQUIRED: 'when required',
    IMMEDIATELY: 'immediately',
    BEFORE_FOOD: 'before food',
    AFTER_FOOD: 'after food'
};

const PRESCRIPTION_FREQUENCY = [
    {
        abbreviated_value: 'once daily',
        value: PRESCRIPTION_FREQUENCY_VALUES.ONCE_DAILY
    },
    {
        abbreviated_value: 'every day',
        value: PRESCRIPTION_FREQUENCY_VALUES.EVERY_DAY
    },
    {
        abbreviated_value: 'twice daily',
        value: PRESCRIPTION_FREQUENCY_VALUES.TWICE_DAILY
    },
    {
        abbreviated_value: 'three times daily',
        value: PRESCRIPTION_FREQUENCY_VALUES.THREE_TIMES_DAILY
    },
    {
        abbreviated_value: 'four times daily',
        value: PRESCRIPTION_FREQUENCY_VALUES.FOUR_TIMES_DAILY
    },
    {
        abbreviated_value: 'five times daily',
        value: PRESCRIPTION_FREQUENCY_VALUES.FIVE_TIMES_DAILY
    },
    {
        abbreviated_value: 'every four hours',
        value: PRESCRIPTION_FREQUENCY_VALUES.EVERY_FOUR_HOURS
    },
    {
        abbreviated_value: 'every morning',
        value: PRESCRIPTION_FREQUENCY_VALUES.EVERY_MORNING
    },
    {
        abbreviated_value: 'every night',
        value: PRESCRIPTION_FREQUENCY_VALUES.EVERY_NIGHT
    },
    {
        abbreviated_value: 'once a week',
        value: PRESCRIPTION_FREQUENCY_VALUES.ONCE_WEEKLY
    },
    {
        abbreviated_value: 'twice a week',
        value: PRESCRIPTION_FREQUENCY_VALUES.TWICE_WEEKLY
    },
    {
        abbreviated_value: 'three times a week',
        value: PRESCRIPTION_FREQUENCY_VALUES.THREE_TIMES_WEEKLY
    },
    {
        abbreviated_value: 'as required',
        value: PRESCRIPTION_FREQUENCY_VALUES.AS_REQUIRED
    },
    {
        abbreviated_value: 'when required',
        value: PRESCRIPTION_FREQUENCY_VALUES.WHEN_REQUIRED
    },
    {
        abbreviated_value: 'immediately',
        value: PRESCRIPTION_FREQUENCY_VALUES.IMMEDIATELY
    },
    {
        abbreviated_value: 'before food',
        value: PRESCRIPTION_FREQUENCY_VALUES.BEFORE_FOOD
    },
    {
        abbreviated_value: 'after food',
        value: PRESCRIPTION_FREQUENCY_VALUES.AFTER_FOOD
    }
];

const TOXINS = {
    AZZALURE: 'Azzalure',
    BOTOX: 'Botox',
    DYSPORT: 'Dysport',
    XEOMIN: 'Xeomin',
    MYOBLOC: 'Myobloc'
};

const JOURNEY_FORM_TYPES = {
    PMH: 'PMH',
    CONSENT: 'Consent'
};

const JOURNEY_FORM_METHODS = {
    IN_PERSON: 'In person',
    ONLINE: 'Online'
};

/**
 * @deprecated use treatmentImages.js or getDefaultTreatmentPhotoByGender
 */
const DEFAULT_TREATMENT_PHOTO = {
    label: 'Default treatment photo',
    url: `${
        typeof localStorage !== 'undefined'
            ? // eslint-disable-next-line no-undef
              JSON.parse(localStorage.getItem('linkCache'))?.backendUrl
            : process.env.COLLUMS_API_URL
    }/images/front_face.jpg`,
    name: 'Default'
};

/**
 * @deprecated use treatmentImages.js
 */
const DEFAULT_TREATMENT_PHOTOS = [
    {
        label: 'Default treatment photo',
        url: `${
            typeof localStorage !== 'undefined'
                ? // eslint-disable-next-line no-undef
                  JSON.parse(localStorage.getItem('linkCache'))?.backendUrl
                : process.env.COLLUMS_API_URL
        }/images/full_face.jpg`,
        name: 'Full Face'
    },
    {
        label: 'Upper face for treatment photo',
        url: `${
            typeof localStorage !== 'undefined'
                ? // eslint-disable-next-line no-undef
                  JSON.parse(localStorage.getItem('linkCache'))?.backendUrl
                : process.env.COLLUMS_API_URL
        }/images/upper_face.jpg`,
        name: 'Upper Face'
    },
    {
        label: 'Lower face for treatment photo',
        url: `${
            typeof localStorage !== 'undefined'
                ? // eslint-disable-next-line no-undef
                  JSON.parse(localStorage.getItem('linkCache'))?.backendUrl
                : process.env.COLLUMS_API_URL
        }/images/lower_face.jpg`,
        name: 'Lower Face'
    }
];

const LOGO_HEIGHT = 75;

const PREFERRED_PHONE_COUNTRIES = ['gb', 'fr', 'it', 'es', 'ie'];
const DEFAULT_PHONE_COUNTRY = 'gb';
const DEFAULT_PHONE_COUNTRY_CODE = '+44';

const TC_MERGE_TAGS = ['{LateCancellationType}', '{LateCancellationValue}', '{LateCancellationPeriod}'];
const TC_MODAL_MERGE_TAGS = ['{LateCancellationPeriod}', '{LateCancellationFee}'];
const DROPDOWN_MAX_SHOWING_ITEMS = 10;

const COUNTRY_CODES = {
    'United Kingdom': 'gb',
    Australia: 'au'
};

const COUNTRY_PHONE_CODES = {
    'United Kingdom': '+44',
    Australia: '+61'
};

const LHR_HANDPIECES = {
    ET: 'ET',
    HS: 'HS'
};

const LHR_SIDES = {
    NA: 'N/a',
    Both: 'Both',
    Left: 'Left',
    Right: 'Right'
};

const LHR_COOLING = {
    Yes: 'Yes',
    No: 'No'
};

const LHR_SKIN_TYPES = Array(6)
    .fill(1)
    .map((item, index) => (item + index).toString());

const SELECTED_HP_LHR_PW = ['Auto', '30', '100', '400'];
const LHR_PWS = ['20', '21', '22'];
const WEEK_DAYS = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

const TREATMENT_LIST = ['Complaint', 'General', 'Prescription', 'Test Results'];

const LHR_TREATMENT_AREAS = {
    ABDOMEN: 'Abdomen',
    ARM_FULL: 'Arm - Full',
    ARM_LOWER: 'Arm - Lower',
    ARM_UPPER: 'Arm - Upper',
    BACK: 'Back',
    BACK_LOWER: 'Back Lower',
    BACK_UPPER: 'Back Upper',
    BEARD: 'Beard',
    BIKINI: 'Bikini',
    BIKINI_BRAZILIAN: 'Bikini - Brazilian',
    BIKINI_HOLLYWOOD: 'Bikini - Hollywood',
    CHEEKS: 'Cheeks',
    CHEST: 'Chest',
    CHIN: 'Chin',
    EARS: 'Ears',
    EYEBROWS: 'Eyebrows',
    FACE_FULL: 'Face - Full',
    FACE_LOWER: 'Face - Lower',
    FACE_UPPER: 'Face - Upper',
    FINGERS: 'Fingers',
    FOOT: 'Foot',
    HAND: 'Hand',
    JAW: 'Jaw',
    LABIA: 'Labia',
    FULL_LEG: 'Leg - Full',
    LOWER_LEG: 'Leg - Lower',
    UPPER_LEG: 'Leg - Upper',
    LIP_BOTTOM: 'Lip - Bottom',
    LIP_TOP: 'Lip - Top',
    NAVEL_PUBIS: 'Navel Pubis',
    NECK: 'Neck',
    NIPPLE: 'Nipple',
    NOSE: 'Nose',
    PERIANAL: 'Perianal',
    SHOULDERS: 'Shoulders',
    SIDEBURNS: 'Sideburns',
    STOMACH: 'Stomach',
    THIGH: 'Thigh',
    TOES: 'Toes',
    UNDERARMS: 'Underarms'
};

const BOTOX_TREATMENT_AREAS = {
    AXILLA: 'Axilla',
    BUNNY_LINES: 'Bunny lines',
    CHIN: 'Chin',
    DAO: 'DAO',
    EYEBROWS: 'Eyebrows',
    EYES: 'Eyes',
    FEET: 'Feet',
    FOREHEAD: 'Forehead',
    GLABELLA: 'Glabella',
    GUMMY_SMILE: 'Gummy smile',
    HANDS: 'Hands',
    LIPS: 'Lips',
    MASSETER: 'Masseter',
    NECK: 'Neck',
    PERI_ORAL: 'Peri oral',
    PLATYSMAL_BANDS: 'Platysmal bands',
    TEMPORALIS: 'Temporalis',
    UNDER_EYE: 'Under eye',
    OTHER: 'Other'
};

const VIEW_BY_OPTIONS = {
    DAY_BY_DAY: 'Day by day',
    DAILY: 'Grouped by day',
    WEEKLY: 'Grouped by week',
    MONTHLY: 'Grouped by month',
    YEARLY: 'Grouped by year'
};

const FORMS_ACTIONS_LOG = {
    CREATED: 'Form created',
    UPDATED: 'Form updated',
    NOT_CHANGED: 'Form not changed - confirmed previous data',
    SIGNED: 'Form signed'
};

const NOTE_ACTIONS_LOG = {
    CREATED: 'Created note',
    UPDATED: 'Updated note'
};

const ORGANISATION_FORMS_TARGET = {
    CLIENT: 'Client',
    PRACTITIONER: 'Practitioner'
};

const EMAIL_FORM_FOR = {
    FIRST_APPOINTMENT_ONLY: '1st appointment only',
    EVERY_APPOINTMENT: 'Every appointment'
};

const DEFAULT_UNIT_VALUES = Array(10)
    .fill(0.5)
    .map((_, index) => _ + index * 0.5);

const TREATMENT_TAG_TYPES = {
    TOXIN: 'toxin',
    FILLER: 'filler',
    LHR: 'lhr'
};

const MEDICAL_HISTORY_SELECTIONS = {
    LABEL: 'Label',
    DESCRIPTION: 'Description'
};

const PRODUCT_VOL_UNITS = {
    MLS: 'mls',
    FLOZ: 'FlOz',
    UNITS: 'Units'
};

const FILLER_AREAS = {
    ANY: 'Any',
    ABDOMEN_LOWE: 'Abdomen - lower',
    ABDOMEN_UPPER: 'Abdomen - upper',
    ARM: 'Arm',
    BROW: 'Brow',
    BUTTOCKS: 'Buttocks',
    CHEEK_BUCCAL: 'Cheek - buccal',
    CHEEKS_MALAR: 'Cheek - malar',
    CHEEKS: 'Cheeks',
    CHIN: 'Chin',
    DECOLLETAGE: 'Décolletage',
    FOREHEAD: 'Forehead',
    GLABELLA: 'Glabella',
    HANDS: 'Hands',
    JAW_ANGLE_OF: 'Jaw - angle of',
    JAW_LINE: 'Jaw line',
    KNEES: 'Knees',
    LIPS: 'Lips',
    MARIONETTE: 'Marionette',
    MENTAL_CREASE: 'Mental crease',
    MOUTH_CORNER: 'Mouth Corner',
    NASOLABIAL: 'Nasolabial',
    NECK: 'Neck',
    NOSE: 'Nose',
    ORAL_COMMISSURE: 'Oral commissure',
    PAROTID_AREA: 'Parotid area',
    PERI_OCCULAR: 'Peri-occular',
    PERI_ORAL: 'Peri oral',
    PRE_JOWL: 'Pre jowl',
    TEAR_TROUGH: 'Tear trough',
    TEMPLE: 'Temple',
    THIGHS: 'Thighs',
    UNDER_EYE: 'Under eye',
    UPPER_ARM: 'Upper Arm',
    ZYGOMA: 'Zygoma',
    OTHER: 'Other'
};

const COLLUMS_ACCESS_TIER = {
    STARTUP_ACCESS: 'Startup Access',
    BUILDER_ACCESS: 'Builder Access',
    EXPERT_ACCESS: 'Expert Access'
};

const COLLUMS_APPS_ACCESS_TIER = {
    CALENDAR: COLLUMS_ACCESS_TIER.STARTUP_ACCESS,
    REPORTING: COLLUMS_ACCESS_TIER.STARTUP_ACCESS,
    CUSTOMER: COLLUMS_ACCESS_TIER.STARTUP_ACCESS,
    ADMIN: COLLUMS_ACCESS_TIER.STARTUP_ACCESS,
    POS: COLLUMS_ACCESS_TIER.STARTUP_ACCESS,
    SCHEDULES: COLLUMS_ACCESS_TIER.STARTUP_ACCESS,

    JOURNEY: COLLUMS_ACCESS_TIER.BUILDER_ACCESS,

    MARKETING: COLLUMS_ACCESS_TIER.EXPERT_ACCESS,
    STOCK: COLLUMS_ACCESS_TIER.EXPERT_ACCESS
};

const JOURNEY_STEPS_ORDER = [
    'home',
    'client-details',
    'forms',
    'form-complete',
    'summary',
    'practitioner-forms',
    'photos'
];

const ACCOUNTING_TYPE = {
    SALES: 'Sales',
    REVENUE: 'Revenue'
};

const COLLUMS_DOMAIN = '.collums.co.uk';

const COOKIE_KEYS = {
    EXP_TIME: 'expTime',
    LOGOUT_ACTIVE: 'logoutActive',
    TOKEN: 'token'
};

const LOCAL_STORAGE_KEYS = {
    TOKEN_KEY: 'token',
    USER_KEY: 'user'
};

const ORGANISATION_VOUCHER_DEFAULT = 1001;

const DEPOSIT_TYPES = {
    NO_DEPOSIT: 'No deposit',
    PERCENTAGE: 'Percentage',
    FIXED_AMOUNT: 'Fixed amount'
};

const DEPOSIT_MULTISERVICE_RULE = {
    SINGLE: 'single',
    SUM: 'sum'
};

const DEPOSIT_RULE = {
    EACH_TIME: 'each time',
    ACCOUNT_DIFFERENCE: 'account difference'
};

const SHOW_TOTALS_BY = {
    GRAND_TOTAL: 'Grand Total',
    DAY: 'Day',
    WEEK: 'Week',
    MONTH: 'Month',
    YEAR: 'Year'
};

const GROUP_BY = {
    COURSE: 'Category - Course',
    PRODUCT: 'Category - Product',
    SERVICE: 'Category - Service',
    ITEM_NAME: 'Item Name',
    ITEM_TYPE: 'Item Type',
    LOCATION: 'Location',
    PROMOTIONAL_DISCOUNT: 'Promotional Discount',
    STAFF_SALES: 'Staff Sales',
    TAGS: 'Tags'
};

const COUNT_BY = {
    TOTAL: 'Total',
    TOTAL_COUNT: '#',
    DISCOUNT: 'Discount',
    NET_PRICE: 'Net Price',
    TAX: 'Tax',
    AVE_NET_SALE: 'Ave Net Sale'
};

const COMPARE_WITH_OPTIONS = {
    NONE: 'None',
    BEFORE: 'Period Immediately Before',
    LAST_WEEK: 'Same Period Last Week',
    LAST_MONTH: 'Same Period Last Month',
    LAST_YEAR: 'Same Period Last Year'
};

const RESERVATION_MESSAGES = {
    TIME_EXPIRED: 'Your payment wasn’t received within the allowed time. Please book a new appointment and try again.'
};

const NOTIFICATIONS_WITH_MULTICLINIC = [
    'Appointment Confirmation',
    'Appointment Reschedule',
    'Appointment Cancellation',
    '1st appointment reminder',
    '2nd appointment reminder',
    'Invoice Payment'
];

const NOTIFICATIONS_FOR_REMOTE_SERVICES = [
    'Appointment Confirmation',
    'Appointment Reschedule',
    'Appointment Cancellation',
    '1st appointment reminder',
    '2nd appointment reminder'
];

const CUSTOMER_DEFAULT_FIELDS = [
    { label: 'Title', name: 'title', show: true, required: false },
    { label: 'Email', name: 'email', show: true, required: true, disabled: true },
    { label: 'First name', name: 'firstName', show: true, required: true, disabled: true },
    { label: 'Last name', name: 'surname', show: true, required: true, disabled: true },
    { label: 'Middle name', name: 'middleName', show: true, required: false, disabled: false },
    { label: 'Mobile', name: 'mobilePhone', show: true, required: false },
    { label: 'Other phone', name: 'otherPhoneType', show: true, required: false },
    { label: 'Postcode', name: 'postal', show: true, required: false },
    { label: 'Prv Surname', name: 'prevSurname', show: true, required: false },
    { label: 'Address line 1', name: 'address1', show: true, required: false },
    { label: 'Aka', name: 'aka', show: true, required: false },
    { label: 'Address line 2', name: 'address2', show: true, required: false },
    { label: 'Dob', name: 'dateOfBirth', show: true, required: true },
    { label: 'City', name: 'city', show: true, required: false },
    { label: 'Gender', name: 'gender', show: true, required: false },
    { label: 'County', name: 'county', show: true, required: false },
    { label: 'Country', name: 'country', show: true, required: false },
    { label: 'Referral source', name: 'referralSource', show: true, required: false },
    { label: 'Referred by', name: 'referredBy', show: true, required: false },
    { label: 'Ethnicity', name: 'ethnicity', show: false, required: false },
    { label: 'Patient status', name: 'patientStatus', show: false, required: false },
    { label: 'Passport/ID', name: 'passportId', show: false, required: false },
    { label: 'NHS no', name: 'nhsNumber', show: false, required: false },
    { label: 'Occupation', name: 'occupation', show: false, required: false },
    { label: 'Height', name: 'height', show: false, required: false },
    { label: 'Weight', name: 'weight', show: false, required: false }
];

const CREATE_NEW_TEMPLATE_OPTION = { name: '-- Create new template --', isCreateNew: true };

const LEADS_DEFAULT_FIELDS = [
    { label: 'Title', name: 'title', show: true, required: false },
    { label: 'Email', name: 'email', show: true, required: true, disabled: true },
    { label: 'First name', name: 'firstName', show: true, required: true, disabled: true },
    { label: 'Last name', name: 'surname', show: true, required: true, disabled: true },
    { label: 'Middle name', name: 'middleName', show: true, required: false, disabled: false },
    { label: 'Mobile', name: 'mobilePhone', show: true, required: false },
    { label: 'Other phone', name: 'otherPhoneType', show: true, required: false },
    { label: 'Postcode', name: 'postal', show: true, required: false },
    { label: 'Prv Surname', name: 'prevSurname', show: true, required: false },
    { label: 'Address line 1', name: 'address1', show: true, required: false },
    { label: 'Aka', name: 'aka', show: true, required: false },
    { label: 'Address line 2', name: 'address2', show: true, required: false },
    { label: 'Dob', name: 'dateOfBirth', show: true, required: true },
    { label: 'City', name: 'city', show: true, required: false },
    { label: 'Gender', name: 'gender', show: true, required: false },
    { label: 'County', name: 'county', show: true, required: false },
    { label: 'Country', name: 'country', show: true, required: false },
    { label: 'Referral source', name: 'referralSource', show: true, required: false },
    { label: 'Referred by', name: 'referredBy', show: true, required: false },
    { label: 'Ethnicity', name: 'ethnicity', show: false, required: false },
    { label: 'Patient status', name: 'patientStatus', show: false, required: false },
    { label: 'Passport/ID', name: 'passportId', show: false, required: false },
    { label: 'NHS no', name: 'nhsNumber', show: false, required: false },
    { label: 'Occupation', name: 'occupation', show: false, required: false },
    { label: 'Height', name: 'height', show: false, required: false },
    { label: 'Weight', name: 'weight', show: false, required: false }
];

const CUSTOMER_DEFAULT_FIELDS_FOR_CUSTOMER_APP = [
    { label: 'Title', name: 'title', show: true, required: false },
    { label: 'First name', name: 'firstName', show: true, required: true, disabled: true },
    { label: 'Last name', name: 'surname', show: true, required: true, disabled: true },
    { label: 'Dob', name: 'dateOfBirth', show: true, required: false },
    { label: 'Email', name: 'email', show: true, required: true, disabled: true },
    { label: 'Mobile', name: 'mobilePhone', show: true, required: false },
    { label: 'Gender', name: 'gender', show: true, required: false },
    { label: 'Address line 1', name: 'address1', show: false, required: false },
    { label: 'Address line 2', name: 'address2', show: false, required: false },
    { label: 'City', name: 'city', show: false, required: false },
    { label: 'County', name: 'county', show: false, required: false },
    { label: 'Country', name: 'country', show: false, required: false },
    { label: 'Postcode', name: 'postal', show: false, required: false },
    { label: 'Referral source', name: 'referralSource', show: true, required: false }
];

const HEIGHT_OPTIONS = [
    { label: 'Under 130 cm (Under 4\'3")', value: 129 },
    { label: '130 cm (4\'3")', value: 130 },
    { label: '132 cm (4\'4")', value: 132 },
    { label: '135 cm (4\'5")', value: 135 },
    { label: '137 cm (4\'6")', value: 137 },
    { label: '140 cm (4\'7")', value: 140 },
    { label: '142 cm (4\'8")', value: 142 },
    { label: '145 cm (4\'9")', value: 145 },
    { label: '147 cm (4\'10")', value: 147 },
    { label: '150 cm (4\'11")', value: 150 },
    { label: '152 cm (5\'0")', value: 152 },
    { label: '155 cm (5\'1")', value: 155 },
    { label: '157 cm (5\'2")', value: 157 },
    { label: '160 cm (5\'3")', value: 160 },
    { label: '163 cm (5\'4")', value: 163 },
    { label: '165 cm (5\'5")', value: 165 },
    { label: '168 cm (5\'6")', value: 168 },
    { label: '170 cm (5\'7")', value: 170 },
    { label: '173 cm (5\'8")', value: 173 },
    { label: '175 cm (5\'9")', value: 175 },
    { label: '178 cm (5\'10")', value: 178 },
    { label: '180 cm (5\'11")', value: 180 },
    { label: '183 cm (6\'0")', value: 183 },
    { label: '185 cm (6\'1")', value: 185 },
    { label: '188 cm (6\'2")', value: 188 },
    { label: '191 cm (6\'3")', value: 191 },
    { label: '193 cm (6\'4")', value: 193 },
    { label: '196 cm (6\'5")', value: 196 },
    { label: '198 cm (6\'6")', value: 198 },
    { label: '201 cm (6\'7")', value: 201 },
    { label: '203 cm (6\'8")', value: 203 },
    { label: '206 cm (6\'9")', value: 206 },
    { label: '208 cm (6\'10")', value: 208 },
    { label: '210 cm (6\'11")', value: 210 },
    { label: 'Over 210 cm (Over 6\'11")', value: 211 }
];

const HEIGHT_DEFAULT = 168;

const WEIGHT_OPTIONS = [
    { label: 'Under 40 kg (Under 6st 4lb)', value: 39 },
    { label: '40 kg (6st 4lb)', value: 40 },
    { label: '45 kg (7st 1lb)', value: 45 },
    { label: '50 kg (7st 12lb)', value: 50 },
    { label: '55 kg (8st 9lb)', value: 55 },
    { label: '60 kg (9st 6lb)', value: 60 },
    { label: '65 kg (10st 3lb)', value: 65 },
    { label: '70 kg (11st 0lb)', value: 70 },
    { label: '75 kg (11st 11lb)', value: 75 },
    { label: '80 kg (12st 8lb)', value: 80 },
    { label: '85 kg (13st 5lb)', value: 85 },
    { label: '90 kg (14st 2lb)', value: 90 },
    { label: '95 kg (14st 13lb)', value: 95 },
    { label: '100 kg (15st 10lb)', value: 100 },
    { label: '105 kg (16st 7lb)', value: 105 },
    { label: '110 kg (17st 4lb)', value: 110 },
    { label: '115 kg (18st 2lb)', value: 115 },
    { label: '120 kg (18st 13lb)', value: 120 },
    { label: '125 kg (19st 10lb)', value: 125 },
    { label: '130 kg (20st 7lb)', value: 130 },
    { label: '135 kg (21st 4lb)', value: 135 },
    { label: '140 kg (22st 1lb)', value: 140 },
    { label: '145 kg (22st 12lb)', value: 145 },
    { label: '150 kg (23st 9lb)', value: 150 },
    { label: '155 kg (24st 6lb)', value: 155 },
    { label: '160 kg (25st 3lb)', value: 160 },
    { label: 'Over 160 kg (Over 25st 3lb)', value: 161 }
];

const WEIGHT_DEFAULT = 65;

const PHOTO_CONSENT_OPTIONS = ['None', 'Marketing', 'Educational', 'In clinic'];

module.exports = {
    TITLES,
    GIFTCARD,
    GENDERS,
    DEFAULT_PHOTO,
    REFERRAL_SOURCES_TYPE,
    DEFAULT_ETHNICITY_OPTIONS,
    DEFAULT_STATUS_OPTIONS,
    MARKETING_DATA_FIELD_NAMES,
    NOTIFICATION_TYPES,
    PHONE_TYPE_OPTIONS,
    RELATIONSHIPS,
    PROFESSIONAL_BODIES,
    COMMISSION_RANGE_TYPES,
    AMOUNT_FEE_TYPE,
    ROLES,
    ORDER,
    POPUP,
    LATE_CANCELLATION_CHARGE,
    SERVICE_AVAILABILITIES,
    APPOINTMENT_TYPES,
    APPOINTMENT_REPEAT,
    APPOINTMENT_PAYMENT_TYPES,
    INVOICE_PAYMENT_TYPES,
    APPOINTMENT_STATUS_TYPES,
    INVOICE_ORIGIN,
    STOCK_TAKE,
    TAXTYPES,
    STATUS_ACTIVE,
    STATUS_DELETED,
    TEST_EMAILS,
    TEMPORARY_DISCOUNTS,
    INVOICE_PAYMENT_STATUS,
    DISCOUNT_TYPES,
    RECEIPT_STATUS,
    APPOINTMENT_FILTER_GROUPS,
    INVOICE_ITEM_TYPES,
    COURSES_GROUP,
    WIDGET_TYPES,
    ORGANISATION_FORM_TYPES,
    WIDGET_GROUPS,
    IMAGE_WIDGET_ALIGNMENT,
    IMAGE_WIDGET_SIZE,
    FORM_OPTIONS,
    PRESCRIPTION_ROUTES,
    DOSE_UNITS,
    DURATION_UNITS,
    TREATMENT_NOTE_TYPES,
    TREATMENT_TYPES,
    TREATMENT_AREAS,
    PRODUCT_TYPES,
    DILUTION_UNITS,
    PRESCRIPTION_FREQUENCY,
    PRESCRIPTION_FREQUENCY_VALUES,
    TOXINS,
    JOURNEY_FORM_TYPES,
    JOURNEY_FORM_METHODS,
    DEFAULT_TREATMENT_PHOTO,
    DEFAULT_PAYMENT_TYPES,
    CURRENCY_TYPES,
    FIXED_PAYMENT_OPTIONS,
    LOGO_HEIGHT,
    PREFERRED_PHONE_COUNTRIES,
    DEFAULT_PHONE_COUNTRY,
    DEFAULT_PHONE_COUNTRY_CODE,
    TC_MERGE_TAGS,
    TC_MODAL_MERGE_TAGS,
    DROPDOWN_MAX_SHOWING_ITEMS,
    SELECTED_HP_LHR_PW,
    LHR_PWS,
    LHR_SKIN_TYPES,
    LHR_SIDES,
    LHR_HANDPIECES,
    COMMISSION_CONDITIONS,
    WEEK_DAYS,
    TREATMENT_LIST,
    LHR_TREATMENT_AREAS,
    BOTOX_TREATMENT_AREAS,
    FORMS_ACTIONS_LOG,
    NOTE_ACTIONS_LOG,
    ORGANISATION_FORMS_TARGET,
    EMAIL_FORM_FOR,
    DEFAULT_UNIT_VALUES,
    TREATMENT_TAG_TYPES,
    MEDICAL_HISTORY_SELECTIONS,
    DEFAULT_TREATMENT_PHOTOS,
    PRODUCT_VOL_UNITS,
    FILLER_AREAS,
    COLLUMS_ACCESS_TIER,
    COLLUMS_APPS_ACCESS_TIER,
    JOURNEY_STEPS_ORDER,
    ACCOUNTING_TYPE,
    COLLUMS_DOMAIN,
    COOKIE_KEYS,
    LOCAL_STORAGE_KEYS,
    ORGANISATION_VOUCHER_DEFAULT,
    COUNTRY_CODES,
    COUNTRY_PHONE_CODES,
    LHR_COOLING,
    COHERENT_PAYMENT_PROCESS_STATUS,
    DEPOSIT_TYPES,
    DEPOSIT_MULTISERVICE_RULE,
    DEPOSIT_RULE,
    VIEW_BY_OPTIONS,
    RELATIONSHIP_TYPE,
    SHOW_TOTALS_BY,
    GROUP_BY,
    COUNT_BY,
    COMPARE_WITH_OPTIONS,
    MEDICAL_TYPES,
    MEDICAL_TYPES_COLOURS,
    LEAD_STATUS,
    LEAD_STAGES_PROTECTED,
    ONLINE_PURCHASE_INVOICE_DESCRIPTION,
    GIFT_VOUCHER_AMOUNT,
    RESERVATION_MESSAGES,
    NOTIFICATIONS_WITH_MULTICLINIC,
    NOTIFICATIONS_FOR_REMOTE_SERVICES,
    CUSTOMER_DEFAULT_FIELDS,
    CUSTOMER_DEFAULT_FIELDS_FOR_CUSTOMER_APP,
    LEADS_DEFAULT_FIELDS,
    CREATE_NEW_TEMPLATE_OPTION,
    HEIGHT_OPTIONS,
    HEIGHT_DEFAULT,
    WEIGHT_OPTIONS,
    WEIGHT_DEFAULT,
    PHOTO_CONSENT_OPTIONS
};
